/* eslint-disable jsx-a11y/anchor-is-valid */
/* eslint-disable jsx-a11y/anchor-has-content */
/* eslint-disable jsx-a11y/alt-text */
/* eslint-disable array-callback-return */
/* eslint-disable no-unused-vars */
/* eslint-disable react/jsx-pascal-case */
import React, { Component, Fragment } from "react";
import { shopContext } from "../../contexts/aniplus";
import { withRouter } from "react-router-dom";
import axios from "axios";

// import NewContentList from "./NewContentList";

import Event202210_contentList from "./Event202210_contentList";
import Event202210_cart from "./Event202210_cart";
import Event202210_pop from "./Event202210_pop";
import Event202210_quest from "./Event202210_quest";
import Locker from "../../components/event/Locker";
//import '../../css/event210621.css'

import "../../css/event220916.css";
//import '../../css/event220916_2.css'
import { toast } from "react-toastify"; //토스트(toast)
import moment from "moment";
// import { isMobile } from "react-device-detect";
import { Modal } from "react-responsive-modal";

class Event202210_newContent extends Component {
  state = {
    eventCode: 0,
    grade: 1,
    kecode: "",
    show: false,
    reset: false,
    intReturn: -101,

    showQuest: false,
    qlist: null,
    contentSerial: 0,

    showOld: false,
    showO: false,
    showX: false,

    list: [],
  };
  componentDidMount = () => {
    this._getData();
    this._getContentList(1);
  };
  _getData = async () => {
    const result = await this._getDataApi();
    const success = result.data[0].success;
    const intReturn = result.data[0].intReturn;
    const orderList = result.data[0].listData;

    if (intReturn === 0) {
      this.setState({
        orderList,
        success,
      });

      //alert(list[0].title + '/' + list[1].title + '/' + list[0].idx + '/' + list[0].regDate)
    } else {
      toast.error("뽑기내역이 존재하지 않습니다.");
    }
  };

  _getDataApi = () => {
    const { apiUrl } = this.props;

    return axios.post(apiUrl + "/event_202210_list", {
      params: {},
    });
  };
  _getContentList = async (eventCode) => {
    // const { loginId } = this.props;

    // const curDate = new Date();
    // const today = moment(curDate).format("YYYY-MM-DD HH:mm:ss");

    const result = await this._getContentListApi(eventCode);
    const intReturn = result.data[0].intReturn;
    const contentList = result.data[0].listData;

    //console.log(contentList)

    if (intReturn === 0) {
      this.setState({
        intReturn,
        contentList,
      });
    }
  };

  _getContentListApi = (eventCode) => {
    const { apiUrl, loginId } = this.props;

    return axios
      .post(apiUrl + "/event_202210_content", {
        params: {
          eventCode: eventCode,
          userid: loginId,
        },
      })
      .then((response) => response)
      .catch((error) => {
        //console.log('error...')
      });
  };

  _timeTable = () => {
    const { setTimelineWeek } = this.props;
    const curDate = new Date();
    const today = moment(curDate).format("YYYY-MM-DD HH:mm:ss");

    let os = "";

    const mobile = /iphone|ipad|ipod|android/i.test(
      navigator.userAgent.toLowerCase()
    );

    if (mobile) {
      const userAgent = navigator.userAgent.toLowerCase();
      if (userAgent.search("android") > -1) {
        os = "android";
      } else if (
        userAgent.search("iphone") > -1 ||
        userAgent.search("ipod") > -1 ||
        userAgent.search("ipad") > -1
      ) {
        os = "ios";
      } else {
        os = "otehr";
      }
    } else {
      os = "pc";
    }

    if (today <= "2021-12-28 00:00:00") {
      toast.warn("12월 28일 이후 확인이 가능합니다.");
    } else {
      //alert(0)
      //setEventIdx(0)
      if (os === "pc") {
        setTimelineWeek(true);
      } else {
        if (os === "ios") {
          setTimeout(function () {
            window.open("https://apps.apple.com/kr/app/id687631772", "", "");
          }, 1500);

          window.location.href = "aniplustv://TimeTable";
        } else {
          //setTimeout(function () {
          //window.open(android_appstore_url);
          //}, 1500);

          window.location.href = "aniplustv://TimeTable";
        }

        //this.action_app('aniplustv://TimeTable', 'aniplustv://TimeTable', 'https://itunes.apple.com/kr/app/instagram/id687631772', 'https://play.google.com/store/apps/details?id=com.aniplustv.android')
      }
    }
  };
  _goGoogle = () => {
    window.open(
      "https://docs.google.com/forms/d/e/1FAIpQLSdJ4d9VfD9fFOtk_KRXS8Oh4_y4WJplQNU8V2rV-MlnJBnzPQ/viewform?usp=sf_link",
      "",
      ""
    );
  };
  _setGrade = (grade) => {
    this.setState({
      grade,
    });

    //if(grade === 4) {
    //주문
    //    this._licens()
    //}
  };
  _makeKeycode = () => {
    const keycode = Math.random().toString(36).substr(2, 11);

    this.setState({
      keycode: keycode,
    });
  };

  _licens = async () => {
    const result = await this._licensApi();
    const intReturn = result.data[0].intReturn;
    const list = result.data[0].listData;

    if (intReturn === 0) {
      this.setState({
        list,
        show: true,
        showQuest: false,
      });

      //alert(list[0].title + '/' + list[1].title + '/' + list[0].idx + '/' + list[0].regDate)
    } else {
      toast.error("확인이 가능합니다.");
    }
  };
  _expect = async (contentSerial, img, title, alramFlag, grade) => {
    const { list, keycode } = this.state;

    let code = "";
    //console.log(keycode)
    if (keycode === "" || keycode === null || keycode === undefined) {
      this._makeKeycode();
    } else {
      code = keycode;
    }

    //if(list.length >= 3) {
    //toast.warn('3개까지만 주문이 가능합니다.')

    //} else {
    //console.log(list.length)
    const result = list.find((item, index) => {
      return item.contentSerial === contentSerial;
    });

    if (result === undefined || result === null || result === "") {
      if (list.length >= 5) {
        //자동 응모처리 여기서
        toast.warn("5개까지만 선택이 가능합니다.");
        return 0;
      } else {
        //신직, 구작 여부 확인 후 문제 오픈!

        const result = await this._expertApi(contentSerial);
        const intReturn = result.data[0].intReturn;

        console.log(intReturn);

        const qlist = result.data[0].listData;
        if (intReturn === 0) {
          //신작 문제
          //console.log(qlist)
          this.setState({
            showQuest: true,
            qlist: qlist,
            contentSerial: contentSerial,
          });
          //return 100
        } else if (intReturn === -1) {
          //구작 선택
          //console.log('구작선택')
          this.setState({
            showOld: true,
            contentSerial: contentSerial,
          });
          return 100;
        } else if (intReturn === -2) {
          console.log("문제 미등록");
        }

        /*
                        list.push( {contentSerial: contentSerial, img: img, title: title, alramFlag: 100 } )
                 
                        this.setState({
                            list: list,
                            reset: false
                        })

                       
                        if(list.length === 5) {
                            this._order()
                        }
    
                        return 100
                        */
      }
    } else {
      //toast.warn('이미 같은 콘텐츠가 존재합니다.')
      //삭제 -- 기능이 없을경우 주석처리.
      const result = list.findIndex((item, index) => {
        return item.contentSerial === contentSerial;
      });

      //console.log(result)
      //console.log(list)

      list.splice(result, 1);

      this.setState({
        list: list,
        reset: false,
      });
      return 0;
    }
    //}
  };
  _expertApi = (contentSerial) => {
    const { apiUrl, loginId } = this.props;

    return axios
      .post(apiUrl + "/event_202210_question", {
        params: {
          contentSerial: contentSerial,
        },
      })
      .then((response) => response)
      .catch((error) => {
        //console.log('error...')
      });
  };

  _reset = () => {
    this.setState({
      eventCode: 0,
      grade: 1,
      kecode: "",
      show: false,
      reset: false,
      contentSerial: 0,
      showQuest: false,
      showO: false,
      showX: false,
      showOld: false,
      intReturn: -101,
      list: [],
    });
    this._makeKeycode();
    this._getContentList(1);
  };
  _order = async () => {
    const { list, keycode } = this.state;
    let contentSerial = "";
    if (list.length <= 0) {
      toast.warn("작품을 선택해주세요.");
    } else {
      list.map((item, index) => {
        contentSerial = contentSerial + item.contentSerial + "|";
      });

      //console.log(contentSerial, keycode)

      const result = await this._orderApi(contentSerial, keycode);
      const intReturn = result.data[0].intReturn;
      const success = result.data[0].success;
      //console.log(intReturn)
      if (intReturn === 0) {
        //레이어 팝업 띄울것...팝업에서 ip adress로 최신거 목록 불러올것.!!!!!
        this.setState({
          show: true,
          showQuest: false,
          reset: success === 0 ? true : false,
        });
      }
    }
  };
  _orderApi = (contentSerial, keycode) => {
    const { apiUrl, loginId } = this.props;

    return axios
      .post(apiUrl + "/event_202210_order", {
        params: {
          contentSerial: contentSerial,
          keycode: keycode,
        },
      })
      .then((response) => response)
      .catch((error) => {
        //console.log('error...')
      });
  };

  _close = () => {
    this.setState({
      show: false,
    });
  };
  _show = () => {
    this.setState({
      show: true,
      showQuest: false,
    });
  };
  _go = () => {
    window.open(
      "https://docs.google.com/forms/d/e/1FAIpQLSdJ4d9VfD9fFOtk_KRXS8Oh4_y4WJplQNU8V2rV-MlnJBnzPQ/viewform?usp=sf_link",
      "",
      ""
    );
  };
  _onCloseQuest = () => {
    this.setState({
      showQuest: false,
    });
  };
  _onSolution = async (contentSerial, snum) => {
    const { list, contentList } = this.state;
    //console.log(contentSerial, snum)
    //정답 확인할 것....api url event_202210_solution

    const result = await this._onSolutionApi(contentSerial, snum);
    const intReturn = result.data[0].intReturn;

    if (intReturn === 0) {
      //console.log('정답')
      contentList.find((item, index) => {
        if (item.contentSerial === contentSerial) {
          item.alramFlag = 100;
        }
      });
      //console.log(contentList)
      //updateList.alramFlag = 100

      list.push({
        contentSerial: contentSerial,
        img: "/img/event/event220916/quick_01.png",
        alramFlag: 100,
      });

      //list.push( {contentSerial: contentSerial, img: img, title: title, alramFlag: 100 } )

      this.setState({
        list: list,
        reset: false,
        showQuest: false,
        contentList: contentList,
      });
      //console.log(contentList)

      //응모내역 저장(팝업창 오픈)
      if (list.length === 5) {
        this._order();
      } else {
        setTimeout(() => {
          this.setState({
            showO: true,
          });
        }, 500);
      }

      //정답창 보여줄것
    } else {
      //console.log('오답')
      //this._reset()
      this._onCloseQuest();

      setTimeout(() => {
        this.setState({
          showX: true,
        });
      }, 500);

      //초기화!

      //오답창 보여줄것.
    }
  };
  _onSolutionApi = (contentSerial, snum) => {
    const { apiUrl } = this.props;
    return axios
      .post(apiUrl + "/event_202210_solution", {
        params: {
          contentSerial: contentSerial,
          snum: snum,
        },
      })
      .then((response) => response)
      .catch((error) => {
        //console.log('error...')
      });
  };
  _onCloseOld = () => {
    this.setState({
      showOld: false,
    });
  };
  _onCloseO = () => {
    this.setState({
      showO: false,
    });
  };
  _onCloseX = () => {
    this.setState({
      showX: false,
    });
  };
  _showList = () => {
    const { list } = this.state;

    if (list.length < 5) {
      alert("보관함을 모두 찾은 후 확인이 가능합니다.");
    }
  };
  render() {
    const {
      grade,
      keycode,
      show,
      list,
      reset,
      orderList,
      contentList,
      intReturn,
      showQuest,
      contentSerial,
      qlist,
      showOld,
      showO,
      showX,
    } = this.state;
    const curDate = new Date();
    const today = moment(curDate).format("YYYY-MM-DD HH:mm:ss");
    return (
      <Fragment>
        <div className="event_head">
          {/*<button type="button" onclick="history.back()"><img src="//img/event/back.png" alt="뒤로"/></button>*/}
          <h3>애니플러스 신작 이벤트</h3>
          <button type="button" className="btnClose">
            <img src="/img/detail_img/close_1.png" alt="닫기" />
          </button>
        </div>
        <div className="eventCon">
          <div className="event220916">
            <div className="popup" style={{ display: showQuest ? "" : "none" }}>
              <div class="popCont">
                <button
                  type="button"
                  className="pop_close"
                  onClick={this._onCloseQuest}
                  style={{ cursor: "pointer", zIndex: 1000 }}
                >
                  <img src="/img/event/event220916/pop_close.png" />
                </button>
                <Event202210_quest
                  contentSerial={contentSerial}
                  qlist={qlist}
                  onSolution={this._onSolution}
                  onCloseQuest={this._onCloseQuest}
                />
              </div>
            </div>
            {show ? (
              <div className="popup">
                <div class="popCont">
                  <button
                    type="button"
                    className="pop_close"
                    onClick={this._close}
                    style={{ cursor: "pointer", zIndex: 1000 }}
                  >
                    <img src="/img/event/event220916/pop_close.png" />
                  </button>
                  <Event202210_pop close={this._close} reset={this._reset} />
                </div>
              </div>
            ) : null}

            <div className="sticky">
              <div className="quick">
                <a href="#top">
                  <img src="/img/event/event220916/quick_01.png" alt="응모" />
                </a>
                <a href="#newList">
                  <img
                    src="/img/event/event220916/quick_02.png"
                    alt="신작목록"
                  />
                </a>
                <a href="#gift">
                  <img src="/img/event/event220916/quick_03.png" alt="경품" />
                </a>
                <a
                  href="#rules"
                  onClick={this._timeTable}
                  style={{ cursor: "pointer" }}
                >
                  <img
                    src="/img/event/event220916/quick_04.png"
                    alt="요일별시간표"
                  />
                </a>
                <a href="#comment">
                  <img src="/img/event/event220916/quick_05.png" alt="댓글" />
                </a>
              </div>
            </div>

            <div className="btm_bar">
              <div className="bar">
                <ul>
                  {/*
                                    <li className="list">
                                        <div className="thumb"><span><img src="/img/event/event211217/sample.png"/></span></div>
                                        <div className="thumb"><span><img src="/img/event/event211217/sample.png"/></span></div>
                                        <div className="thumb"><span><img src="/img/event/event211217/bar_img_coffee.png" alt="준비중"/></span></div>
                                    </li>
                                    */}
                  <Event202210_cart list={list} />

                  <li>
                    <img src="/img/event/event220916/bar_next.png" alt="next" />
                  </li>
                  <li>
                    <button
                      type="button"
                      className={
                        list.length < 5 ? "btn btn01" : "btn btn01 active"
                      }
                      onClick={this._showList}
                    >
                      확인하기
                    </button>
                    <button
                      type="button"
                      className={
                        list.length < 5 ? "btn btn02" : "btn btn02 active"
                      }
                      onClick={this._go}
                      href="#newList"
                    >
                      응모하기
                    </button>
                  </li>
                  {/*
                                    <li>
                                        <button type="button" className={list.length > 0 ? "btn btn01_active" : "btn btn01"} onClick={this._order}>신작 주문하기</button>
                                        <button type="button" className={list.length > 0 ? "btn btn02_active" : "btn btn02"} onClick={this._reset}>새로고침</button>
                                    </li>
                                    <li>
                                        <img src="/img/event/event220916/bar_next.png" alt="next"/>
                                    </li>
                                    <li>
                                        <button type="button" className={orderList ? "btn btn03_active" : "btn btn03"} onClick={this._show}>신작카페 주문 내역서 확인하기</button>
                                        <button type="button" className="btn btn04_active" onClick={this._go}>주문 내역서 인증샷 응모하기</button>
                                    </li>
                                */}
                </ul>
                <img src="/img/event/event220916/bar.png" className="img_web" />
                <img src="/img/event/event220916/m_bar.png" className="img_m" />
              </div>
            </div>

            <div className="main">
              <img
                src="/img/event/event220916/backimg_1.png"
                alt="애니플러스 신작 뽑기"
                className="img_web"
              />
              <img
                src="/img/event/event220916/m_backimg_1.png"
                alt="애니플러스 신작 뽑기"
                className="img_m"
              />
            </div>

            <a name="newList"></a>
            <div className="listWrap">
              <h2>
                <img
                  src="/img/event/event220916/backimg_2.png"
                  alt="애니플러스 신작 보관소"
                  class="img_web"
                />
                <img
                  src="/img/event/event220916/m_backimg_2.png"
                  alt="애니플러스 신작 보관소"
                  class="img_m"
                />
              </h2>
              {contentList ? (
                <Fragment>
                  <Event202210_contentList
                    eventCode={1}
                    keycode={keycode}
                    _setGrade={this._setGrade}
                    _makeKeycode={this._makeKeycode}
                    _expect={this._expect}
                    reset={reset}
                    contentList={contentList.slice(0, 6)}
                    intReturn={intReturn}
                  />

                  <Event202210_contentList
                    eventCode={2}
                    keycode={keycode}
                    _setGrade={this._setGrade}
                    _makeKeycode={this._makeKeycode}
                    _expect={this._expect}
                    reset={reset}
                    contentList={contentList.slice(6, 12)}
                    intReturn={intReturn}
                  />

                  <Event202210_contentList
                    eventCode={3}
                    keycode={keycode}
                    _setGrade={this._setGrade}
                    _makeKeycode={this._makeKeycode}
                    _expect={this._expect}
                    reset={reset}
                    contentList={contentList.slice(12, 18)}
                    intReturn={intReturn}
                  />

                  <Event202210_contentList
                    eventCode={4}
                    keycode={keycode}
                    _setGrade={this._setGrade}
                    _makeKeycode={this._makeKeycode}
                    _expect={this._expect}
                    reset={reset}
                    contentList={contentList.slice(18, 24)}
                    intReturn={intReturn}
                  />

                  <Event202210_contentList
                    eventCode={5}
                    keycode={keycode}
                    _setGrade={this._setGrade}
                    _makeKeycode={this._makeKeycode}
                    _expect={this._expect}
                    reset={reset}
                    contentList={contentList.slice(24, contentList.length)}
                    intReturn={intReturn}
                  />
                </Fragment>
              ) : null}
            </div>

            {/*
                                <Event202207_contentList 
                                    eventCode={2}
                                    keycode={keycode}
                                    _setGrade={this._setGrade}
                                    _makeKeycode={this._makeKeycode}
                                    _expect={this._expect}
                                    reset={reset}
                                />
                               
                                <Event202207_contentList 
                                    eventCode={3}
                                    keycode={keycode}
                                    _setGrade={this._setGrade}
                                    _makeKeycode={this._makeKeycode}
                                    _expect={this._expect}
                                    reset={reset}
                                />
                                <Event202207_contentList 
                                    eventCode={4}
                                    keycode={keycode}
                                    _setGrade={this._setGrade}
                                    _makeKeycode={this._makeKeycode}
                                    _expect={this._expect}
                                    reset={reset}
                                />
                                <Event202207_contentList 
                                    eventCode={5}
                                    keycode={keycode}
                                    _setGrade={this._setGrade}
                                    _makeKeycode={this._makeKeycode}
                                    _expect={this._expect}
                                    reset={reset}
                                />
                                */}
            {/*
                                <Event202201_cart 
                                    list={list}
                                />
                                <div onClick={this._order}>주문하기</div>
                                <div onClick={this._reset}>다시선택하기</div>
                                <div onClick={this._show}>내역확인</div>
                                */}

            <div className="btm">
              <a
                name="gift"
                onClick={this._timeTable}
                className="link"
                style={{ cursor: "pointer" }}
              ></a>
              <img
                src="/img/event/event220916/backimg_3.png"
                alt="경품내용 및 주의사항"
                className="img_web"
              />
              <img
                src="/img/event/event220916/m_backimg_3.png"
                alt="경품내용 및 주의사항"
                className="img_m"
              />
            </div>
          </div>

          {/*구작 팝업 */}

          <Modal
            open={showOld}
            showCloseIcon={false}
            closeOnOverlayClick={false}
            closeOnEsc={false}
            center
            styles={{ modal: { backgroundColor: "black" } }}
          >
            <Locker
              contentSerial={contentSerial}
              flag={"O"}
              onCloseX={this._onCloseOld}
            />
          </Modal>
          {/*구작 팝업 */}

          {/*정답 팝업 */}
          <Modal
            open={showO}
            showCloseIcon={false}
            closeOnOverlayClick={false}
            closeOnEsc={false}
            center
            styles={{ modal: { backgroundColor: "black" } }}
          >
            <Locker
              contentSerial={contentSerial}
              flag={"S"}
              onCloseX={this._onCloseO}
            />
          </Modal>
          {/*정답 팝업 */}

          {/*오답 팝업 */}
          <Modal
            open={showX}
            showCloseIcon={false}
            closeOnOverlayClick={false}
            closeOnEsc={false}
            center
            styles={{ modal: { backgroundColor: "black" } }}
          >
            <div style={{ width: 250, height: 120, textAlign: "center" }}>
              <div
                style={{
                  color: "#fff",
                  fontSize: 16,
                  fontWeight: 700,
                  paddingTop: 10,
                }}
              >
                땡! 보관에 실패했어요 ㅠ
              </div>
              <div
                style={{
                  color: "#ff5d24",
                  fontSize: 12,
                  fontWeight: 700,
                  paddingTop: 10,
                }}
              >
                * 다시 한번 생각해볼까요?
              </div>
              <div style={{ width: 250, paddingTop: 20 }}>
                <div
                  style={{
                    backgroundColor: "#fff",
                    width: 50,
                    height: 25,
                    borderRadius: 3,
                    textAlign: "center",
                    margin: "auto",
                  }}
                >
                  <div
                    style={{
                      color: "#000",
                      fontSize: 14,
                      fontWeight: 700,
                      paddingTop: 3,
                      cursor: "pointer",
                    }}
                    onClick={this._onCloseX}
                  >
                    확인
                  </div>
                </div>
              </div>
            </div>
          </Modal>
          {/*오답 팝업 */}
        </div>
        <a name="comment"></a>
      </Fragment>
    );
  }
}

export default shopContext(withRouter(Event202210_newContent));
